// @flow
export const PERSONAL_DATA_REQUEST = 'PERSONAL_DATA_REQUEST';
export const PERSONAL_DATA_REQUESTED_SUCCESS = 'PERSONAL_DATA_REQUESTED_SUCCESS';
export const PERSONAL_DATA_REQUESTED_ERROR = 'PERSONAL_DATA_REQUESTED_ERROR';

export const PERSONAL_DATA_FORM_UPDATE = 'PERSONAL_DATA_FORM_UPDATE';
export const PERSONAL_DATA_FORM_ERROR = 'PERSONAL_DATA_FORM_ERROR';
export const PERSONAL_DATA_FORM_SUCCESS = 'PERSONAL_DATA_FORM_SUCCESS';

export const PERSONAL_DATA_FORM_RESET = 'PERSONAL_DATA_FORM_RESET';

export const PERSONAL_DATA_FIRST_LOAD = 'PERSONAL_DATA_FIRST_LOAD';

export const OPEN_CV_PREVIEW = 'OPEN_CV_PREVIEW';
